module.exports = __webpack_public_path__ + "img/sopa-letras-crucigrama.0d198dbc.svg";